/* ==========================================================================
   Kuba Home Nova — comportamento das seções "Home · …"
   Vanilla JS, idempotente (o editor de temas recarrega seções).
   ========================================================================== */
(function () {
  'use strict';
  if (window.__khLoaded) { window.__khInit && window.__khInit(); return; }
  window.__khLoaded = true;
  document.documentElement.classList.add('kh-js');

  var io = null;
  function reveal() {
    var els = document.querySelectorAll('.kh-rv:not(.in)');
    if (!els.length) return;
    if (!('IntersectionObserver' in window)) { els.forEach(function (e) { e.classList.add('in'); }); return; }
    if (!io) {
      io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (en.isIntersecting) { en.target.classList.add('in'); io.unobserve(en.target); }
        });
      }, { rootMargin: '0px 0px -12% 0px', threshold: 0.08 });
    }
    els.forEach(function (e) { io.observe(e); });
  }

  /* --- estilos do botão real de scroll (substitui a seta ::before, que não era clicável) --- */
  function hsStyles() {
    if (document.getElementById('kh-hs-styles')) return;
    var s = document.createElement('style');
    s.id = 'kh-hs-styles';
    s.textContent = [
      '.kh-hs.kh-hs--btn::before{display:none!important}',
      '.kh-hs__next{position:absolute;right:12px;top:50%;transform:translateY(-50%);z-index:5;width:44px;height:44px;padding:0;border:0;border-radius:50%;background:var(--kh-red,#9B2C22);color:var(--kh-cream,#FBF5F3);font-family:inherit;font-size:16px;line-height:1;cursor:pointer;display:none;align-items:center;justify-content:center;transition:opacity .3s,background .2s,transform .2s}',
      '.kh-hs__next:hover{background:var(--kh-red-light,#C4483C)}',
      '.kh-hs__next:active{transform:translateY(-50%) scale(0.94)}',
      '.kh-hs--always>.kh-hs__next{display:flex}',
      '@media(max-width:719px){.kh-hs>.kh-hs__next{display:flex}}',
      '.kh-hs[data-hs-end="1"]>.kh-hs__next{opacity:0;pointer-events:none}',
      '.kh-hs__prev{position:absolute;left:12px;top:50%;transform:translateY(-50%);z-index:5;width:44px;height:44px;padding:0;border:0;border-radius:50%;background:var(--kh-red,#9B2C22);color:var(--kh-cream,#FBF5F3);font-family:inherit;font-size:16px;line-height:1;cursor:pointer;display:none;align-items:center;justify-content:center;transition:opacity .3s,background .2s,transform .2s}',
      '.kh-hs__prev:hover{background:var(--kh-red-light,#C4483C)}',
      '.kh-hs__prev:active{transform:translateY(-50%) scale(0.94)}',
      '.kh-hs--always>.kh-hs__prev{display:flex}',
      '@media(max-width:719px){.kh-hs>.kh-hs__prev{display:flex}}',
      '.kh-hs[data-hs-start="0"]>.kh-hs__prev{opacity:0;pointer-events:none}'
    ].join('');
    document.head.appendChild(s);
  }

  /* logos (imprensa e clientes): os PNGs vêm com margens transparentes diferentes.
     Mede a área desenhada de cada um e reposiciona o <img> para essa área ocupar a caixa.
     Imprensa: todos com a mesma altura. Clientes: área visual parecida (logo largo não domina). */
  var khTrimCache = {};
  function khTrimBounds(src) {
    if (!khTrimCache[src]) {
      khTrimCache[src] = new Promise(function (res) {
        var p = new Image();
        p.crossOrigin = 'anonymous';
        p.onload = function () {
          try {
            var w = p.naturalWidth, h = p.naturalHeight, c = document.createElement('canvas');
            c.width = w; c.height = h;
            var x = c.getContext('2d'); x.drawImage(p, 0, 0);
            var d = x.getImageData(0, 0, w, h).data, t = h, b = -1, l = w, r = -1;
            for (var y = 0; y < h; y++) for (var i = 0; i < w; i++) {
              if (d[(y * w + i) * 4 + 3] > 16) { if (y < t) t = y; if (y > b) b = y; if (i < l) l = i; if (i > r) r = i; }
            }
            res(b < 0 ? null : { w: w, h: h, l: l, t: t, cw: r - l + 1, ch: b - t + 1 });
          } catch (e) { res(null); }
        };
        p.onerror = function () { res(null); };
        p.src = src;
      });
    }
    return khTrimCache[src];
  }
  function khTrimPlace(img, bd) {
    var box = img.parentElement, W = box.clientWidth, H = box.clientHeight;
    if (!bd || !W || !H) return;
    var s = Math.min(W / bd.cw, H / bd.ch);
    if (box.classList.contains('kh-biz__logo')) s = Math.min(s, Math.sqrt(0.5 * W * H / (bd.cw * bd.ch)));
    var st = img.style;
    st.position = 'absolute'; st.maxWidth = 'none'; st.objectFit = 'fill';
    st.width = (bd.w * s) + 'px'; st.height = (bd.h * s) + 'px';
    st.left = ((W - bd.cw * s) / 2 - bd.l * s) + 'px';
    st.top = ((H - bd.ch * s) / 2 - bd.t * s) + 'px';
  }
  function trimLogos() {
    document.querySelectorAll('.kh-presscard__logo img, .kh-biz__logo img').forEach(function (img) {
      if (img.__khTrim) return;
      img.__khTrim = true;
      var go = function () {
        var src = img.currentSrc || img.src;
        if (!src) return;
        khTrimBounds(src).then(function (bd) { img.__khBd = bd; khTrimPlace(img, bd); });
      };
      if (img.complete && img.naturalWidth) go(); else img.addEventListener('load', go, { once: true });
    });
  }
  window.addEventListener('resize', function () {
    document.querySelectorAll('.kh-presscard__logo img, .kh-biz__logo img').forEach(function (img) { if (img.__khBd) khTrimPlace(img, img.__khBd); });
  });

  function horizontalScroll() {
    hsStyles();
    document.querySelectorAll('.kh-hs').forEach(function (w) {
      var sc = w.querySelector('.kh-scroll') || w.firstElementChild;
      if (!sc || sc.__khHs) return;
      sc.__khHs = true;
      var upd = function () {
        var more = sc.scrollWidth - sc.clientWidth - sc.scrollLeft > 12;
        w.setAttribute('data-hs-end', more ? '0' : '1');
        var moved = sc.scrollLeft > 12;
        w.setAttribute('data-hs-start', moved ? '1' : '0');
      };
      sc.addEventListener('scroll', upd, { passive: true });
      window.addEventListener('resize', upd);

      /* seta clicável: avança uma "página" do carrossel */
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'kh-hs__next';
      btn.setAttribute('aria-label', 'Ver mais');
      btn.innerHTML = '<svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M9 5l7 7-7 7"/></svg>';
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        var pad = parseFloat(getComputedStyle(sc).scrollPaddingLeft) || 0;
        var step = Math.max(180, Math.round((sc.clientWidth - pad) * 0.8));
        if (sc.scrollBy) sc.scrollBy({ left: step, behavior: 'smooth' });
        else sc.scrollLeft = sc.scrollLeft + step;
        setTimeout(upd, 450);
      });
      w.classList.add('kh-hs--btn');
      w.appendChild(btn);

      /* seta clicável: volta uma "página" do carrossel (só aparece depois de rolar) */
      var btnPrev = document.createElement('button');
      btnPrev.type = 'button';
      btnPrev.className = 'kh-hs__prev';
      btnPrev.setAttribute('aria-label', 'Ver anteriores');
      btnPrev.innerHTML = '<svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M15 5l-7 7 7 7"/></svg>';
      btnPrev.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        var pad = parseFloat(getComputedStyle(sc).scrollPaddingLeft) || 0;
        var step = Math.max(180, Math.round((sc.clientWidth - pad) * 0.8));
        if (sc.scrollBy) sc.scrollBy({ left: -step, behavior: 'smooth' });
        else sc.scrollLeft = sc.scrollLeft - step;
        setTimeout(upd, 450);
      });
      w.appendChild(btnPrev);

      upd();
    });
  }

  /* --- router: filtro por tipo de produto + card-guia da categoria --- */
  function router() {
    document.querySelectorAll('[data-kh-router]').forEach(function (sec) {
      if (sec.__kh) return;
      sec.__kh = true;
      var chips = sec.querySelectorAll('[data-kh-cat]');
      var leads = sec.querySelectorAll('[data-kh-lead]');
      var empty = sec.querySelector('[data-kh-empty]');
      var first = chips[0];
      /* categoria que já chega marcada (data-kh-default); sem ela, o primeiro chip */
      var def = sec.getAttribute('data-kh-default');
      var hasDef = false;
      chips.forEach(function (c) { if (c.getAttribute('data-kh-cat') === def) hasDef = true; });
      var state = { cat: hasDef ? def : (first ? first.getAttribute('data-kh-cat') : 'todos') };

      function matches(card) {
        var type = card.getAttribute('data-type') || '';
        var wireless = card.getAttribute('data-wireless') === 'true';
        if (state.cat === 'todos') return true;
        if (state.cat === 'semfio') return wireless;
        return type === state.cat;
      }
      function apply() {
        var visible = 0;
        sec.querySelectorAll('.kh-pitem').forEach(function (card) {
          var show = matches(card);
          card.hidden = !show;
          if (show) visible++;
        });
        chips.forEach(function (c) { c.classList.toggle('is-on', c.getAttribute('data-kh-cat') === state.cat); });
        var shown = false;
        leads.forEach(function (l) {
          var on = l.getAttribute('data-kh-lead') === state.cat && !shown;
          l.hidden = !on;
          if (on) shown = true;
        });
        if (!shown && leads.length) { leads[0].hidden = false; }
        if (empty) empty.hidden = visible > 0;
        /* o card-guia começa hidden no HTML: o snap já tinha travado no 1º produto — volta pro início */
        var sc = sec.querySelector('.kh-scroll');
        if (sc) { sc.scrollLeft = 0; sc.dispatchEvent(new Event('scroll')); requestAnimationFrame(function () { sc.scrollLeft = 0; sc.dispatchEvent(new Event('scroll')); }); }
      }
      chips.forEach(function (c) {
        c.addEventListener('click', function () { state.cat = c.getAttribute('data-kh-cat'); apply(); });
      });
      sec.querySelectorAll('[data-kh-clear]').forEach(function (b) {
        b.addEventListener('click', function () { state.cat = first ? first.getAttribute('data-kh-cat') : 'todos'; apply(); });
      });
      apply();
    });
  }

  /* --- marquees: duração proporcional à largura do conteúdo --- */
  function marquee() {
    document.querySelectorAll('.kh-mq').forEach(function (w) {
      if (w.__kh) return;
      w.__kh = true;
      var track = w.querySelector('.kh-mq__track');
      if (!track) return;
      var speed = parseFloat(w.getAttribute('data-kh-speed')) || 55; /* px por segundo */
      var upd = function () {
        var secs = Math.max(24, Math.round(track.scrollWidth / 2 / speed));
        track.style.setProperty('--kh-marquee-dur', secs + 's');
      };
      window.addEventListener('resize', upd);
      setTimeout(upd, 300);
      upd();
    });
  }

  function anchors() {
    document.querySelectorAll('.kh a[href^="#"]').forEach(function (a) {
      if (a.__kh) return;
      a.__kh = true;
      a.addEventListener('click', function (e) {
        var id = a.getAttribute('href').slice(1);
        var t = id && document.getElementById(id);
        if (t) { e.preventDefault(); t.scrollIntoView({ behavior: 'smooth', block: 'start' }); }
      });
    });
  }

  function init() {
    reveal(); horizontalScroll(); router(); marquee(); anchors(); trimLogos();
    setTimeout(reveal, 900);
    setTimeout(horizontalScroll, 900);
  }
  window.__khInit = init;

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();

  document.addEventListener('shopify:section:load', function () { setTimeout(init, 50); });
  document.addEventListener('shopify:section:select', function () {
    document.querySelectorAll('.kh-rv').forEach(function (e) { e.classList.add('in'); });
  });
})();
